import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { convertToRuFormat } from "../../utilits/helpers/convertDateFormat"; 
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import IconButton from '@mui/material/IconButton';
import { backUrl } from "../../config"; 

const cuttedBaseUrl = backUrl.split("/").slice(0, 3).join("/");



const Files = ({attachments, uploadedFiles }) => {
  return (
      <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
        {attachments.map((file) => {
          return (
            <ListItem key={file.id}>
              <ListItemAvatar>
                <Avatar>
                  <PictureAsPdfIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={file.name}
                secondary={convertToRuFormat(file.createdAt)}
              />
              <IconButton>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={`${cuttedBaseUrl}${file.url}`}
                >
                  <CloudDownloadIcon
                    style={{ cursor: "pointer" }}
                    color="primary"
                  />
                </a>
              </IconButton>
            </ListItem>
          );
        })}
        {uploadedFiles.map((file) => {
          return (
            <ListItem key={file.id}>
              <ListItemAvatar>
                <Avatar>
                  <PictureAsPdfIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={file.name}
                secondary={convertToRuFormat(file.createdAt)}
              />
              <IconButton>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={`${cuttedBaseUrl}${file.url}`}
                >
                  <CloudDownloadIcon
                    style={{ cursor: "pointer" }}
                    color="primary"
                  />
                </a>
              </IconButton>
            </ListItem>
          );
        })}
      </List>
  );
};

export default Files;
